import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-estatutos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './estatutos.component.html',
  styleUrls: ['./estatutos.component.scss']
})
export class EstatutosComponent {
}
